import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppEnvironmentService } from '../../app-common/services';
import { select, Store } from '@ngxs/store';
import { LoggedInUserState } from '@modules/auth/store/loggedInUser.state';
import { UserRole } from 'generated/graphql';

@Injectable()
export class ProjectAppleGuard implements CanActivate {
  router = inject(Router);
  appEnv = inject(AppEnvironmentService);
  store = inject(Store);

  user = select(LoggedInUserState.getLoggedInUser);

  canActivate() {
    const user = this.user();

    if (this.appEnv.ENABLE_PROJECT_APPLE()) {
      return true;
    } else {
      if (!user) {
        return false;
      }
      if (user.role === UserRole.Student) {
        return this.router.parseUrl('/student');
      } else if (user.role === UserRole.Teacher) {
        return this.router.parseUrl('/teacher');
      } else {
        return false;
      }
    }
  }
}
